import React from 'react'
import classNames from 'classnames'
import arrowOrange from '../images/arrow-rust.svg'
import styles from './accordion.module.scss'

const Accordion = ({
  key,
  title,
  open,
  onToggle,
  className,
  activeClassName,
  children
}) => {
  return (
    <div
      className={ classNames( styles.accordion, {
        [ styles.open ]: open
      }, className, {
        [ activeClassName ]: open
      })}
     >
      <button className={ styles.header } onClick={ onToggle }>
        <span className={ styles.title }>{ title }</span>

        <span className={ styles.angle }>
          <img src={ arrowOrange } alt={ title } />
        </span>
      </button>

      <div className={ styles.content }>
        { children }
      </div>
    </div>
  )
}

export default Accordion